<template>
  <notification :notification="notification">
    <template slot="title">
      您关注的会员
      <router-link
          :to="{name: 'users.threads', params: {user_uuid: notification.user_info ? notification.user_info.user_uuid : ''}}"
          >
            《
                <img :src="notification.user_info ? notification.user_info.user_avatar : ''"
               :alt="notification.user_info ? notification.user_info.nick_name : ''" class="avatar-30">
               {{ notification.user_info.nick_name }}
            》
      </router-link>
      ，发布了新动态
      <router-link :to="{name: 'threads.show', params: {dynamic_id: notification.relation.dynamic_id}}">
        《{{ notification.relation.dynamic_title }}》
      </router-link>
    </template>
  </notification>
</template>

<script>
import Notification from './notification'

export default {
  components: { Notification },
  props: {
    notification: {
      type: Object,
      default: null
    }
  }
}
</script>
